
export default {
  props: {
    icon: {
      type: Object,
      required: true,
    },
    iconActive: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    hoverred: false,
  }),
  computed: {
    isActive() {
      return this.iconActive && this.icon.key === this.iconActive.key
    },
  },
}
